import { useEffect, useRef, useState } from "react";
import { useDispatchApp } from "../lib/redux";
import {
  startListenerSupportSessions,
  stopListenerSupportSessions,
} from "../actions/supportSessions";
import { canScheduleSupportSession } from "../utils/supportSessions";

const useSupportSessionsQuota = () => {
  const dispatch = useDispatchApp();
  const listenerRef = useRef(null);
  const [supportSessions, setSupportSessions] = useState(null);
  const [isSupportSessionsResolved, setIsSupportSessionsResolved] =
    useState(false);

  useEffect(() => {
    let isMounted = true;

    dispatch(
      startListenerSupportSessions({
        onReferenceAvailable: (reference) => {
          listenerRef.current = reference;
        },
        onUpdatedDataCallback: (data) => {
          if (!isMounted) return;
          setSupportSessions(data);
          setIsSupportSessionsResolved(true);
        },
      })
    );

    return () => {
      isMounted = false;
      dispatch(
        stopListenerSupportSessions({
          listenerRef: listenerRef.current,
        })
      );
      listenerRef.current = null;
    };
  }, [dispatch]);

  const canSchedule = canScheduleSupportSession({ supportSessions });

  return {
    supportSessions,
    canScheduleSupportSession: canSchedule,
    isSupportSessionsResolved,
  };
};

export default useSupportSessionsQuota;
